module.exports = __webpack_public_path__ + "static/media/page_hd.91b14e3a.jpg";